module.exports = __webpack_public_path__ + "static/img/MoorePeter_Fluxhall1964.a2dae6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/MoorePeter_Fluxhall1964.jpg
// module id = 70Y1
// module chunks = 0